<template>
  <q-form @submit="this.onSubmit" class="form">
    <div class="form__item">
      <CustomSelect
        :options="this.residencyOptions"
        label="ЖК"
        optionValueKey="resident_id"
        optionLabelKey="resident_name"
        :value="this.formData.resident_id || ''"
        @change="(value) => onChange('resident_id', value)"
        :required="true"
      />
    </div>
    <div class="form__item">
      <CustomSelect
        :options="this.frameOptions"
        label="Тип конструкции"
        optionValueKey="frame_type_id"
        optionLabelKey="frame_type_name"
        :value="this.formData.frame_type_id || ''"
        @change="(value) => onChange('frame_type_id', value)"
        :required="true"
      />
    </div>
    <div class="form__item">
      <CustomInput
        label="Название конструкции"
        type="text"
        :value="this.formData.frame_name"
        @change_input="(value) => onChange('frame_name', value)"
        :required="true"
      />
    </div>
    <div class="form__content">
      <CustomUploader
        :value="formData.frame"
        :on-change="(value) => onChange('frame', value)"
        label="Фотография"
        :fullWidth="true"
      />
      <a
        download
        target="_blank"
        rel="noopener noreferrer"
        v-if="!!this.formData.frame_url"
        :href="`${API_URL}${formData.frame_url}`"
        link
      >
        <q-icon name="fa-solid fa-download" />&nbsp;Скачать оригинал
      </a>
    </div>
    <CustomModalFooter :btn-loading="this.loading" />
  </q-form>
</template>
<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomSelect from "@/components/form/CustomSelect";
import CustomInput from "@/components/form/CustomInput";
import CustomUploader from "@/components/form/CustomUploader";
import { getFrameOptions } from "./services";
import { API_URL } from "@/constants";

export default {
  name: "frame-upd",
  components: { CustomSelect, CustomInput, CustomModalFooter, CustomUploader },
  props: ["data"],
  data() {
    return {
      frameOptions: [],
      loading: false,
      steps: [],
      residencyOptions: this.data.residencyOptions || [],
      formData: {
        frame_id: this.data?.body?.frame_id || "",
        resident_id: this.data?.resident_id || "",
        frame_type_id: this.data?.body?.frame_type_id || "",
        frame_name: this.data?.body?.frame_name || "",
        frame_url: this.data?.body?.frame_url || "",
        frame: "",
      },
    };
  },
  methods: {
    async onChange(key, value) {
      this.formData[key] = value;
    },
    async onSubmit() {
      this.loading = true;
      if (this.formData.frame) {
        this.formData.frame = this.formData.frame[0];
      }
      await this.data?.onSubmit(this.formData);
      this.loading = false;
    },
    async getFrameTypes() {
      const res = await getFrameOptions();
      this.frameOptions = res || [];
    },
  },
  mounted() {
    this.getFrameTypes();
  },
};
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  min-width: 350px;
  gap: 20px;

  @media (max-width: 428px) {
    min-width: 100%;
  }
}
</style>
